<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import Vue from "vue";
import store from "./store";

export default {
    components: {
    },
    props: [],
    data() {
        return {
            dummy: null
        }
    },
    mounted() {
        window.bus.$on("reloadDataFromServer", () => {
            document.querySelector('body').click()
            CmsApi.hook("/hooks/login/",{},(data) => {
                if (data.success && data.data) window.bus.setData({ user: data.data, admin: window.bus.admin });
                window.bus.$emit("dataReloaded", data)
            });
        });
    },
    methods: {
        dummyFunction() {
            return false;
        }
    }
}
</script>

